import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Package, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const RICEFWAnalysis = ({ project }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [project.id]);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${API}/projects/${project.id}/discovery/ricefw`);
      setData(response.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !data) return <Loader2 className="w-12 h-12 animate-spin mx-auto mt-20" />;

  const categories = [
    { key: 'reports', label: 'Reports', color: 'blue', icon: '📊' },
    { key: 'interfaces', label: 'Interfaces', color: 'green', icon: '🔌' },
    { key: 'conversions', label: 'Conversions', color: 'purple', icon: '🔄' },
    { key: 'enhancements', label: 'Enhancements', color: 'orange', icon: '⚡' },
    { key: 'forms', label: 'Forms', color: 'pink', icon: '📝' },
    { key: 'workflows', label: 'Workflows', color: 'indigo', icon: '🔀' }
  ];

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6">
      <h3 className="text-2xl font-bold mb-6 flex items-center">
        <Package className="w-6 h-6 mr-3 text-orange-600" />
        RICEFW Objects
      </h3>
      <div className="grid md:grid-cols-6 gap-4 mb-6">
        {categories.map((cat) => (
          <div key={cat.key} className="bg-gray-50 border-2 border-gray-200 rounded-xl p-4 text-center">
            <div className="text-3xl mb-2">{cat.icon}</div>
            <p className="text-sm font-medium mb-1">{cat.label}</p>
            <p className="text-2xl font-bold">{data.breakdown[cat.key]}</p>
          </div>
        ))}
      </div>
      <div className="space-y-4">
        {categories.map((cat) => (
          <div key={cat.key}>
            <h4 className="text-lg font-bold mb-3">{cat.label}</h4>
            <div className="space-y-2">
              {data.objects[cat.key].map((obj, idx) => (
                <div key={idx} className="border-2 border-gray-200 rounded-lg p-4">
                  <p className="font-bold">{obj.name}</p>
                  <p className="text-sm text-gray-600">{obj.type} - {obj.process}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
